import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const v1OrganizationTypesAdapter = getAdapter({ idFieldName: 'value' });

const v1OrganizationTypesSlice = createSlice({
    name: 'v1OrganizationTypes',
    initialState: v1OrganizationTypesAdapter.getInitialState(),
    reducers: {
        setv1OrganizationTypes: (state, { payload: { v1OrganizationTypes } }) => {
            v1OrganizationTypesAdapter.setAll(state, v1OrganizationTypes);
        }
    }
});

const selectors = v1OrganizationTypesAdapter.getSelectors(({ v1OrganizationTypes }) => v1OrganizationTypes);

export const getv1OrganizationTypes = state => selectors.selectAll(state);

export const { setv1OrganizationTypes } = v1OrganizationTypesSlice.actions;
export default v1OrganizationTypesSlice.reducer;